import { paths } from '@luxuryescapes/contract-svc-content';

import { json_headers, request } from './common';

const BASE_URL = `${window.configs.API_HOST}/api/content`;

export const getContentComponentTagBySlug = async (slug: string, brand = 'luxuryescapes') => {
  const response = await request(
    `${BASE_URL}/componentTag/${slug}?date=${new Date().getTime()}&withStatus=true&brand=${brand}`,
    {
      method: 'GET',
    },
  );
  const fields = (response.result[0] as { fields?: Record<string, unknown> })?.fields ?? {};
  return { ...fields, status: response.result[0].status };
};

export type CreateContentComponentTagBodyParams =
  paths['/api/content/componentTag']['post']['requestBody']['content']['application/json'];

export const createContentComponentTag = async (componentTagParams: CreateContentComponentTagBodyParams) => {
  const response = await request(`${BASE_URL}/componentTag`, {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(componentTagParams),
  });
  return response.result.id;
};

export type UpdateContentComponentTagBodyParams =
  paths['/api/content/componentTag/{id}']['put']['requestBody']['content']['application/json'];

export const updateContentComponentTag = async (
  id: string,
  componentTagParams: UpdateContentComponentTagBodyParams,
) => {
  return request(`${BASE_URL}/componentTag/${id}`, {
    method: 'PUT',
    headers: json_headers,
    body: JSON.stringify(componentTagParams),
  });
};

export const deleteContentComponentTag = async (id: string) => {
  return request(`${BASE_URL}/componentTag/${id}`, {
    method: 'DELETE',
  });
};

export const updateContentComponentTagStatus = async (id: string, status: string) => {
  return request(`${BASE_URL}/componentTag/${id}/status`, {
    method: 'PATCH',
    headers: json_headers,
    body: JSON.stringify({ status }),
  });
};
